import api from './api'

// 유저 매장 목록 조회
// https://mealantcloud.atlassian.net/wiki/spaces/PI/pages/1792999481/API
export function getUserRestaurantsList () {
  return api.get('v1/restaurants')
}
